import PropTypes from 'prop-types';
import React from 'react';
import { Field, reduxForm } from 'redux-form';

import ModalBox from '../../shared/modal';
import SelectField from '../../shared/form-elements/select/field';

const Form = props => {
	return (
		<div className='payouts-transaction-form-wrap payouts-form-in-modal'>
			<form
				className='ui-form payouts-form__main clearfix'
				onSubmit={props.handleSubmit(props.distributeAffiliates)}
			>
				<div className='ui-form__element affiliates'>
					<Field
						name='source_admin_id'
						placeholder={props.intl('Admin (manager of source affiliates)')}
						component={SelectField}
						searchable={true}
						multi={false}
						options={props.loadAllAdminsLookup}
					/>
				</div>
				<div className='ui-form__element affiliates'>
					<Field
						name='admin_ids'
						placeholder={props.intl('Managers')}
						component={SelectField}
						searchable={true}
						multi={true}
						options={props.loadAdminsLookup}
					/>
				</div>
				<button
					className='ui-btn ui-btn-primary apply'
					type='submit'
				>{props.intl('Distribute')}</button>
				<button
					className='ui-btn ui-btn-cancel cancel'
					onClick={e => {
						e.preventDefault();
						props.toggleAffiliateDistributionPopup();
					}}
				>{props.intl('Cancel')}</button>
			</form>
		</div>
	);
};

Form.propTypes = {
	managers: PropTypes.array,
	handleSubmit: PropTypes.func,
	distributeAndRemove: PropTypes.func,
	intl: PropTypes.func,
	toggleAffiliateDistributionPopup: PropTypes.func
};

const Main = props =>
	<ModalBox
		title={props.intl('Distribute affiliates from manager to:')}
		body={Form(props)}
		isOpen={props.showAffiliatedDistributionPopup}
		onClose={props.toggleAffiliateDistributionPopup}
		className='form-modal affiliate-distribution-modal'
	/>;

Main.propTypes = {
	toggleAffiliateDistributionPopup: PropTypes.func,
	showAffiliatedDistributionPopup: PropTypes.bool,
	intl: PropTypes.func
};

export default reduxForm({ form: 'affiliateDistributionForm' })(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/admins/components/affiliate-distribution-popup.js